module.exports = __webpack_public_path__ + "static/lauv-preorder-logo-ff5774e8814d5986935434c44daa594a.png";